import { get, post, put, patch } from "./api_helper"

const getCorporateOrdersApi = params => get("admin/rtw-order/page", params)
const getSupplierListApi = params => get("admin/master/company/list", params)
const getYearListApi = ({ id }) => get(`admin/master/fabric/${id}/year/list`)
const getSeasonListApi = () => get(`admin/master/season/list`)
const createCorporateOrdersApi = params => post("admin/rtw-order", params)
const getCorporateOrdersEditApi = ({ id }) => get(`admin/rtw-order/${id}`)
const updateCorporateOrderApi = ({ id, params }) =>
  put(`admin/rtw-order/${id}`, params)
const updateBulkDelivery = ({ id }) =>
  patch(`admin/rtw-order/${id}/bulk-delivery`)
const getInspectionHistoryApi = ({ id }) =>
  get(`admin/rtw-order/${id}/inspection-history`)
const shipOrderApi = ({ id }) => patch(`admin/rtw-order/${id}/shipping`)
const getCSVDataApi = params => get(`admin/rtw-order/csv`, params)
export const getPrintRwtOrder = id =>
  get(`admin/rtw-order/${id}/print`, "", { responseType: "arraybuffer" })

export {
  getCorporateOrdersApi,
  getSupplierListApi,
  getSeasonListApi,
  createCorporateOrdersApi,
  getCorporateOrdersEditApi,
  updateCorporateOrderApi,
  getYearListApi,
  updateBulkDelivery,
  getInspectionHistoryApi,
  shipOrderApi,
  getCSVDataApi,
}
